import apiClient from './apiClient'
import { BotCreateRequest, BotUpdateRequest } from '../types/bot.types'

export const botService = {
  async getBots(): Promise<{ success: boolean; data: { bots: any[]; pagination: any } }> {
    const response = await apiClient.get('/bots')
    return response.data
  },

  async getBot(id: number): Promise<{ success: boolean; data?: any; message?: string }> {
    const response = await apiClient.get(`/bots/${id}`)
    return response.data
  },

  async createBot(botData: BotCreateRequest): Promise<{ success: boolean; data?: any; message?: string }> {
    const response = await apiClient.post('/bots', botData)
    return response.data
  },

  async updateBot(id: number, data: BotUpdateRequest): Promise<{ success: boolean; data?: any; message?: string }> {
    const response = await apiClient.put(`/bots/${id}`, data)
    return response.data
  },

  async deleteBot(id: number): Promise<{ success: boolean; message?: string }> {
    try {
      const response = await apiClient.delete(`/bots/${id}`)
      return response.data
    } catch (error: any) {
      return { success: false, message: error.response?.data?.message || 'Erro ao deletar bot.' }
    }
  },

  async connectBot(id: number): Promise<{ success: boolean; qrCode?: string | null; isConnected?: boolean; message?: string }> {
    try {
      const response = await apiClient.post(`/bots/${id}/connect`)
      return response.data
    } catch (error: any) {
      return { success: false, message: error.response?.data?.message || 'Erro ao conectar bot.' }
    }
  },

  async disconnectBot(id: number): Promise<{ success: boolean; data?: any; message?: string }> {
    try {
      const response = await apiClient.post(`/bots/${id}/disconnect`)
      return response.data
    } catch (error: any) {
      return { success: false, message: error.response?.data?.message || 'Erro ao desconectar bot.' }
    }
  },

  async getBotStatus(id: number): Promise<{ success: boolean; status: string; isConnected: boolean; qrCode?: string }> {
    const response = await apiClient.get(`/whatsapp/${id}/status`)
    return response.data
  },

  async cancelAuthentication(id: number): Promise<{ success: boolean; data?: any; message?: string }> {
    try {
      const response = await apiClient.post(`/bots/${id}/cancel-auth`)
      return response.data
    } catch (error: any) {
      return { success: false, message: error.response?.data?.message || 'Erro ao cancelar autenticação.' }
    }
  },

  // Buscar bots permitidos para o usuário atual
  async getPermittedBots(): Promise<{ success: boolean; data: any[] }> {
    const response = await apiClient.get('/user-bot-permissions/bots/permitted')
    return response.data
  }
}

